export const FETCH_ASSETPRICING_BEGIN = "FETCH_ASSETPRICING_BEGIN";
export const FETCH_ASSETPRICING_SUCCESS = "FETCH_ASSETPRICING_SUCCESS";
export const FETCH_ASSETPRICING_FAILURE = "FETCH_ASSETPRICING_FAILURE";

   